import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-cream warm-glow-light py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-160" data-mp="1j9gwqm2xz77s">
      <div className="mx-auto max-w-3xl px-4" data-id="element-161" data-mp="1n9iqm92fqwci">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-162" data-mp="1ncwpv8fsypfq">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border border-line bg-white shadow-lift" data-id="element-163" data-mp="1x9rp5tjwgtv2">
          <div className="harvest-bar h-2 w-full" aria-hidden="true" data-id="element-164" data-mp="226rwe7shk2nr" />
          <div className="p-6 sm:p-10" data-id="element-165" data-mp="2uyxu6q1up8x">
            <span className="inline-flex items-center gap-2 rounded-md bg-forest px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-goldLight" data-id="element-166" data-mp="2w9y3wkadeva">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="1mh6lr2lyx871" /> Main offer
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-line pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-168" data-mp="1hpg40bkpbi5l">
              <div data-id="element-169" data-mp="1crn1bsilx6a2">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-ink" data-id="element-170" data-mp="1cr4trzqhv5mu">{productName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-171" data-mp="17pxms2w6eah8">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="sm:text-right" data-id="element-172" data-mp="1vhcr217ij1v4">
                <span className="text-sm text-muted" data-id="element-173" data-mp="1vg1p86xmo46n">
                  Regular price <span className="line-through" data-id="element-174" data-mp="1rgar1i5ruls3">{priceBefore}</span>
                </span>
                <p className="mt-1 font-display text-5xl font-extrabold text-forest" data-id="element-175" data-mp="k1xz5bu5v06v">{price}</p>
                <p className="text-xs font-extrabold uppercase tracking-[.16em] text-earth" data-id="element-176" data-mp="g0uiin4ah04l">Today · 66% discount</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-177" data-mp="hiazvj66s1me">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-ink" data-id="element-178" data-mp="mg33vbk3ve6y">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forestSoft" aria-hidden="true" data-id="element-179" data-mp="7jc1ctf4xmd4" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-180" data-mp="3uvw92u8zl38p">
              Get my collection now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-181" data-mp="3kz095cx5lpfr">
              <span className="inline-flex items-center gap-1.5" data-id="element-182" data-mp="3pwrxjwylatf7">
                <LockIcon className="h-4 w-4 text-earth" aria-hidden="true" data-id="element-183" data-mp="3bxs9oriwiik3" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-184" data-mp="3fzx2jo1izb5o">
                <ZapIcon className="h-4 w-4 text-earth" aria-hidden="true" data-id="element-185" data-mp="3g1i0lnn1tc8a" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-186" data-mp="2sc089e3yuf9y">
                <ShieldCheckIcon className="h-4 w-4 text-forestSoft" aria-hidden="true" data-id="element-187" data-mp="2sdutyun2abf3" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-188" data-mp="31cyc9weemmsj">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}